import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface SectionErrorProps {
  message: string;
  onRetry: () => void;
}

export function SectionError({ message, onRetry }: SectionErrorProps) {
  return (
    <div className="rounded-lg border border-destructive/20 bg-destructive/5 p-4 text-center">
      <AlertCircle className="mx-auto h-8 w-8 text-destructive mb-2" />
      <p className="text-sm text-destructive mb-3">{message}</p>
      <Button variant="outline" size="sm" onClick={onRetry}>
        Try again
      </Button>
    </div>
  );
}
